import { useTranslation } from "next-i18next";
import { FC } from "react";

import Header from "@/components/text/header";

import ArticleContentStyles from "../modules/article-content-styles";
import { ArticleHeader } from "../modules/article-header";
import { ChildArticles } from "../modules/child-articles";
import { HelpContactFooter } from "../modules/help-contact-footer";
import { HelpSearch } from "../modules/help-search";
import { PublicArticleLink } from "../types/article";
import styles from "./article.module.scss";

type Props = {
    title: string;
    bodyHtml: string;
    type?: "consumer" | "merchant";
    hideContactUs?: boolean;
    childArticles?: PublicArticleLink[];
    articleToken?: string;
};

export const ArticlePage: FC<Props> = ({
    title,
    bodyHtml,
    type = "consumer",
    hideContactUs,
    childArticles,
    articleToken,
}) => {
    const { t } = useTranslation();
    const pageTitle =
        type === "merchant" ? t("help.header.merchantTitle") : t("help.header.consumerTitle");
    return (
        <div className={styles.article}>
            <Header renderAs="h4" title={pageTitle} className={styles.helpTitle} />
            <HelpSearch type={type} />
            <ArticleHeader title={title} />
            <ArticleContentStyles>
                <div dangerouslySetInnerHTML={{ __html: bodyHtml }} />
            </ArticleContentStyles>
            <ChildArticles childArticles={childArticles} type={type} />
            {!hideContactUs && <HelpContactFooter type={type} articleToken={articleToken} />}
        </div>
    );
};
